import { types, Instance } from 'mobx-state-tree';
const { model, string, identifierNumber, number, maybeNull } = types;

export const EmailTemplateModel = model('EmailTemplateModel', {
  id: identifierNumber,
  sentEvent: string,
  bccTo: maybeNull(string),
  sendTo: string,
  templateSubject: string,
  templateBody: string,
  templateKeywords: string,
  status: types.union(number, types.boolean),
  supportEmail: maybeNull(string),
  templateSignaturePosition: maybeNull(string),
});

export type IEmailTemplateModel = Instance<typeof EmailTemplateModel>;

export const Email = model('Email', {
  id: identifierNumber,
  templateSubject: maybeNull(string),
  templateBody: maybeNull(string),
  template: string,
  templateButton: maybeNull(string),
  templateSignaturePosition: maybeNull(string),
  templateSignatureName: maybeNull(string),
  templateAdminEmail: maybeNull(string),
  templateOrganizationName: maybeNull(string),
  templateProfileImageUrl: maybeNull(string),
  templateUrl: maybeNull(string),
});

export type IEmail = Instance<typeof Email>;
